import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Admin.css';

function AdminConfig({ onLogout }) {
  const [config, setConfig] = useState({ youtube_channel_id: '', featured_video_id: '', contact_email: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`);
      const data = await response.json();
      setConfig(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/config`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(config)
      });

      if (response.ok) {
        alert('Settings saved successfully');
      }
    } catch (error) {
      alert('Error saving settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <nav className="admin-nav">
        <div className="admin-nav-content">
          <h1 className="brand-text">ClutchBabe9 Admin</h1>
          <div className="admin-nav-links">
            <Link to="/admin/dashboard" className="admin-nav-link">Dashboard</Link>
            <Link to="/admin/posts" className="admin-nav-link">Posts</Link>
            <Link to="/admin/videos" className="admin-nav-link">Videos</Link>
            <Link to="/admin/subscribers" className="admin-nav-link">Subscribers</Link>
            <Link to="/admin/contacts" className="admin-nav-link">Contacts</Link>
            <Link to="/admin/profile" className="admin-nav-link">Profile</Link>
            <Link to="/admin/config" className="admin-nav-link active">Settings</Link>
            <Link to="/" className="admin-nav-link view-site-link" data-testid="view-site-btn">🌐 View Site</Link>
            <button onClick={() => { onLogout(); navigate('/admin/login'); }} className="btn btn-ghost">Logout</button>
          </div>
        </div>
      </nav>

      <div className="admin-content">
        <h2>Site Configuration</h2>

        {loading ? (
          <div className="loading-spinner"></div>
        ) : (
          <form onSubmit={handleSubmit} className="admin-form">
            <div className="form-group">
              <label>YouTube Channel ID</label>
              <input
                type="text"
                value={config.youtube_channel_id}
                onChange={(e) => setConfig({ ...config, youtube_channel_id: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Featured Video ID</label>
              <input
                type="text"
                value={config.featured_video_id}
                onChange={(e) => setConfig({ ...config, featured_video_id: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Contact Email</label>
              <input
                type="email"
                value={config.contact_email}
                onChange={(e) => setConfig({ ...config, contact_email: e.target.value })}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save Settings'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default AdminConfig;
